/**
* @copyright Microsoft 2020
*/
export {};
//# sourceMappingURL=Datamodel.js.map